import React, { Fragment, useState, useEffect, useCallback } from "react";

import { DataGrid, GridRowModes, useGridApiRef  } from '@mui/x-data-grid';
import { frFR as dataGridfrFR } from '@mui/x-data-grid/locales';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import { red, common, blue } from '@mui/material/colors';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

import { useAuth } from '#utils/auth';
import { TitlePage } from "#components/TitlePage";
//import { LoadingIcon } from "#components/Loading";
import { TextError, TextTip } from '#components/TextInformation';
import { useApiPackages } from "#services/apiPackages";
import ScrollButtonToTop from '#components/ScrollButtonToTop'
import useFunctions from '#utils/functions';

export function Packages() {

    const { user } = useAuth();
    const api = useApiPackages();

    const { formatDate } = useFunctions();

    const [errorMessage, setErrorMessage] = useState("")

    const [activeTab, setActiveTab] = useState(0);
    const [isWorking, setIsWorking] = useState(false);

    // edit un abonnement (package) -----------------------------------------------------------
    const [rowModesModel, setRowModesModel] = React.useState({});
    const apiRef = useGridApiRef();

    const handleEditClick = (row, event) => {
        setRowModesModel({ ...rowModesModel, [row.upk_id]: { mode: GridRowModes.Edit } });
        apiRef.current.startCellEditMode({id : row.upk_id, field : 'upk_is_active' });
    };

    const handleSaveClick = (row, event) => {
        setRowModesModel({ ...rowModesModel, [row.upk_id]: { mode: GridRowModes.View } });
    };    

    const handleCancelClick = (row, event) => {
        setRowModesModel({ ...rowModesModel, [row.upk_id]: { mode: GridRowModes.View } });
    };        

    // row update
    const handleProcessRowUpdate = useCallback( 
        async  (updatedRow, originalRow) => {
//            console.log(updatedRow, originalRow);
            setIsWorking(true);
            const response = await api.updateData(updatedRow)
            setIsWorking(false);
            if (response.returnCode===0) {
                return updatedRow        
            } else {
                // TODO : Afficher message erreur
                return originalRow        
            }            
        }
        , []
    );

    const handleProcessRowUpdateError = (errors) => {
        console.log(errors);
    }


    //--------------------------------------------------------------
    // définition des listes 

    const refCodeTabs = [
        { code: 'inuse', lib: "en cours", comment: "Abonnements en cours de validité" }
        , { code: 'wait', lib: "en attente", comment: "Abonnements en attente d'activation" }
        , { code: 'history', lib: "Historique" }
    ]

    const baseColumns = [
        { field: 'upk_id', headerName: 'ID', width: 50, type: 'number' },
        { field: 'upk_pri_lib', headerName: 'Abonnement', width: 280},
        {
            field: 'upk_date_start', headerName: 'Début', width: 120, type: 'date', editable : true ,
            valueFormatter: (value) => {
                return formatDate(value || '');
            }
        },
        {
            field: 'upk_date_end', headerName: 'Fin', width: 120, type: 'date', editable : true ,
            valueFormatter: (value) => {
                return formatDate(value || '');
            }
        },
        { field: 'upk_pass_solde', headerName: 'Solde', width: 60, type: 'number' },
        { field: 'upk_is_active', headerName: 'Actif', type: 'boolean', width: 100, editable : true },
        { field: 'upk_usr_libr', headerName: 'Compte', width: 200, sortable : true },
        //{ field: 'upk_usr_firstname', headerName: 'Prénom', width: 150 },
        //{ field: 'upk_usr_name', headerName: 'Nom', width: 150},
        { field: 'actions',             
            type : 'actions', //disableColumnMenu: true, resizable: false, filterable: false, sortable: false, editable: false, groupable: false, 
            headerName: 'Actions',
            width: 90, headerAlign: 'center', align: 'center',            
            renderCell: (params) => {
                const isInEditMode = rowModesModel[params.row.upk_id]?.mode === GridRowModes.Edit;
                if (isInEditMode) {
                    return (
                        <Box>
                            <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleSaveClick(params.row, e)} >
                                <SaveIcon sx={{ color: common[900]}}/> 
                            </IconButton>

                            <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleCancelClick(params.row, e)} >
                                <CancelIcon sx={{ color: red[500] }} />
                            </IconButton>
                        </Box>
                    )
                }
                return (
                    <Box>
                        <IconButton sx={{ ml: 0, px: 0, py: 2, my: 0 }} onClick={(e) => handleEditClick(params.row, e)} >
                            <EditIcon sx={{ color: common[900]}}/> 
                        </IconButton>
                    </Box>
                );
            }   
        }     
    ].map(
        // valeur commune      
        (col) => {
            col.headerClassName = 'app-theme--header';
            col.editable = col.editable || false;  
            col.sortable = col.sortable || false;  // pb disableColumnSorting, on doit l'indiquer pour chaque column !      
            return col;
        }
    );

    // fonction pour init selon les tabs !
    const initFromTabs = (initValue) => {
        let arrayTabs = refCodeTabs.map((x) => x.code);
        let r = {};
        arrayTabs.forEach((tab) => { r[tab] = initValue; });
        return r;
    };

    const columns = initFromTabs(baseColumns);


    //--------------------------------------------------------------            
    const [isTabLoaded, setIsTabLoaded] = useState(initFromTabs(false));
    const [data, setData] = useState(initFromTabs({}));

    //--------------------------------------------------------------        
    const [paginationModel, setPaginationModel] = useState(initFromTabs({
        page: 0,
        pageSize: 25
    }));
    const [filterModel, setFilterModel] = useState(initFromTabs({
        items: []
    }));
    const [sortModel, setSortModel] = useState(initFromTabs(
        []
    ));

    const [rowCount, setRowCount] = useState(initFromTabs(0));

    const onPaginationModelChange = (newPaginationModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...paginationModel };
        temp[keyTab] = newPaginationModel;
        setPaginationModel(temp);
    };

    const onFilterModelChange = (newFilterModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...filterModel };
        temp[keyTab] = newFilterModel;
        setFilterModel(temp);
    };

    const onSortModelChange = (newSortModel) => {
        let keyTab = refCodeTabs[activeTab].code;
        let temp = { ...sortModel };
        temp[keyTab] = newSortModel;
        setSortModel(temp);
    };

    //--------------------------------------------------------------    
    const handleChangeTab = (event, newValue) => {
        setActiveTab(newValue);
    };

    const getRowId = (data) => {
        return data.upk_id;
    }

    useEffect(() => {
        let keyTab = refCodeTabs[activeTab].code;

        if (user) { // && !isTabLoaded[keyTab]) { 
            setIsWorking(true);
            api.getData(keyTab, paginationModel[keyTab], filterModel[keyTab], sortModel[keyTab])
                .then((json) => {
                    setIsWorking(false);
                    let tempL = { ...isTabLoaded };
                    let tempD = { ...data };
                    let tempRC = { ...rowCount }
                    tempL[keyTab] = true;
                    if (json.returnCode === 0) {
                        tempD[keyTab] = json.returnData;
                        tempRC[keyTab] = json.returnTotalDataCount;
                        setErrorMessage('');
                    } else {
                        tempD[keyTab] = {};
                        tempRC[keyTab] = 0;
                        setErrorMessage(json.returnMsg || 'Erreur récupération des réservations');
                    }
                    setData(tempD);
                    setRowCount(tempRC);
                    setIsTabLoaded(tempL);
                });
        }

    }, [user, activeTab, paginationModel, filterModel]);

    //--------------------------------------------------------------        
    const getData = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return (data[key] && data[key].length > 0) ? data[key] : null;
    }
    const getCol = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return (columns[key] && columns[key].length > 0) ? columns[key] : null;
    }
    const getCommentActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].comment;
        return key ? key : '';
    }
    const getRowCountActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return rowCount[key];
    }
    const getPaginationModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return paginationModel[key];
    }
    const getFilterModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return filterModel[key];
    }
    const getSortModelActiveTab = (tabId) => {
        let key = refCodeTabs[tabId].code;
        return sortModel[key];
    }

    const CustomNoRowsOverlay = () => {
        return <Box sx={{ pt: 5, width : '100%', textAlign : 'center' }}>Aucun abonnement</Box>
    }

    return (
        <Fragment>
            <TitlePage titlePage="Abonnements" 
                showAddButton="right" tooltipAddButton="Ajouter un abonnement" routeAddButton="/Admin/Package/Add"
            />

            {errorMessage !== '' && <TextError>{errorMessage}</TextError>}

            <Container sx={{ pt: 2, pb: 4 }} maxWidth="xl">

                {/* les tabs  */}
                <Box sx={{ mb: 2, py: 0, px: 0, borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={activeTab} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                        {
                            refCodeTabs.map((value, index) => (
                                <Tab key={index} label={value.lib} wrapped={true} />
                            ))
                        }
                    </Tabs>
                </Box>
                <TextTip>{getCommentActiveTab(activeTab)}</TextTip> 

                {/* les datas */}                
                <DataGrid
                    width = '100%'
                    localeText={dataGridfrFR.components.MuiDataGrid.defaultProps.localeText}
                    sx={getRowCountActiveTab(activeTab)>0 ? {minHeight:200}: {height:200}} //  important pour afficher l'overlay                        
                    slots={{ 
                        noRowsOverlay: CustomNoRowsOverlay,
                    }}                    
                    density='compact'
                    disableColumnSelector={true}

                    rowModesModel={rowModesModel}
                    //onRowModesModelChange={handleRowModesModelChange}
                    //onRowEditStop={handleRowEditStop}

                    apiRef={apiRef}
                    editMode='row'  
                    processRowUpdate={handleProcessRowUpdate} 
                    onProcessRowUpdateError={handleProcessRowUpdateError}

                    loading={isWorking}
                    getRowId={getRowId}
                    rows={getData(activeTab) || []}
                    rowCount={getRowCountActiveTab(activeTab)}
                    columns={getCol(activeTab)}

                    filterMode="server"
                    onFilterModelChange={onFilterModelChange}
                    filterModel = {getFilterModelActiveTab(activeTab)}                    

                    sortingMode="server"
                    onSortModelChange={onSortModelChange}
                    sortModel = {getSortModelActiveTab(activeTab)}

                    paginationMode="server"
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationModel={getPaginationModelActiveTab(activeTab)}
                    onPaginationModelChange={onPaginationModelChange}
                />
            </Container>

            <ScrollButtonToTop />

        </Fragment>
    );
};